export enum HomeProductPromotionType {
  ONE_CIKAN_OTELLER = 'one_cikan_oteller',
  ONE_CIKAN_TURLAR = 'one_cikan_turlar',
  ONE_CIKAN_YURTICI_TURLAR = 'one_cikan_yurtici_turlar',
}
